export const muiComponentBaseLink = 'https://mui.com/material-ui';
export const muiComponentXLink = 'https://mui.com/x';
export const folderBaseLink = 'src/docs/component-docs';
export const mainDrawerWidth = {
  full: 300,
  slim: 80,
  collapsed: 136,
  stackedNavCollapsed: 72,
};
